/*
  O-RISE, 18/10/2026 — il carrello a tendina.

  Il cassetto NON e' nostro: e' quello nativo del tema (Vessel 4.1.1), acceso
  dall'impostazione `cart_type: drawer`. Qui dentro c'e' solo l'aggancio, perche'
  le nostre sezioni hanno sostituito la testata e il buy box del tema e quindi
  nessuno gli parlava piu'.

  Regola di questo file: se il cassetto non c'e', o se questo modulo non parte,
  NON si rompe niente. Il carrello in testata resta un link a /cart e il bottone
  resta un form vero che fa la sua POST. Lo si vede dai `return` secchi qui sotto.
*/

import { CartLinesUpdateEvent } from '@shopify/events';

const cassetto = () => document.getElementById('cart-drawer');

/* ---- 1. l'icona del carrello in testata apre la tendina ---- */
document.addEventListener('click', (e) => {
  const link = e.target instanceof Element ? e.target.closest('.avori a.cb') : null;
  if (!link) return;
  const d = cassetto();
  if (!d || typeof d.open !== 'function') return; // niente tendina: il link va a /cart
  e.preventDefault();
  d.open();
});

/* ---- 2. il numerino sul carrello segue quello che succede ----
   La testata e' nostra, quindi il conteggio lo rende Liquid al caricamento e
   senza questo resterebbe fermo: aggiungi un prodotto, la tendina dice 2 e
   l'icona dice ancora 1. Il tema aggiorna il suo, non il nostro.
   Si ascolta l'evento standard, che arriva anche quando la quantita' si cambia
   DENTRO la tendina, non solo quando si aggiunge dalla scheda. */
document.addEventListener('shopify:cart:lines-update', async (e) => {
  const link = document.querySelector('.avori a.cb');
  if (!link) return;
  try {
    await e.promise; // si aspetta che la modifica sia davvero andata a buon fine
  } catch {
    return; // e' fallita: meglio un numero vecchio che uno inventato
  }
  let quanti;
  try {
    quanti = (await fetch('/cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    }).then((r) => r.json())).item_count;
  } catch {
    return;
  }
  const badge = link.querySelector('i');
  if (!quanti) {
    badge?.remove();
    return;
  }
  if (badge) badge.textContent = String(quanti);
  else link.insertAdjacentHTML('beforeend', `<i>${quanti}</i>`);
});

/* ---- 3. il buy box della scheda aggiunge senza cambiare pagina ---- */
const form = document.getElementById('av-ori-acquisto');

if (form) {
  form.addEventListener('submit', async (e) => {
    const d = cassetto();
    if (!d || typeof d.open !== 'function') return; // niente tendina: parte la POST normale

    e.preventDefault();

    const dati = new FormData(form);
    dati.delete('return_to'); // serviva solo alla POST che porta via dalla pagina

    // Si chiedono anche le sezioni del carrello, cosi' la tendina si ridisegna
    // con dentro la riga nuova invece di restare a quello che mostrava prima.
    const sezioni = Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
      .map((n) => n.dataset.sectionId)
      .filter(Boolean);
    if (sezioni.length) dati.append('sections', sezioni.join(','));

    const quante = Number(dati.get('quantity')) || 1;
    const atteso = CartLinesUpdateEvent.createPromise();

    // L'evento si lancia PRIMA della chiamata, come fa il tema: il cassetto si
    // apre subito e si riempie quando la promessa si risolve. Se lo lanciassimo
    // dopo, si aprirebbe a cose fatte e sembrerebbe lento.
    form.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: [{ merchandiseId: String(dati.get('id')), quantity: quante }],
        promise: atteso.promise,
      })
    );

    const bottone = form.querySelector('button[type="submit"]');
    bottone?.setAttribute('aria-busy', 'true');

    try {
      const aggiunta = await fetch(window.Theme?.routes?.cart_add_url || '/cart/add', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: dati,
        credentials: 'same-origin',
      });
      const risposta = await aggiunta.json();

      // `status` valorizzato vuol dire rifiuto di Shopify (esaurito, limite, ...).
      // Non e' un errore di rete: la tendina va comunque riallineata al vero.
      const haSbagliato = Boolean(risposta.status);

      const carrello = await fetch('/cart.js', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      }).then((r) => r.json());

      atteso.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(carrello),
        detail: {
          items: carrello.items,
          source: 'av-ori-pdp',
          sourceId: 'av-ori-acquisto',
          itemCount: quante,
          productId: form.dataset.productId,
          sections: risposta.sections,
          didError: haSbagliato,
        },
      });

      if (haSbagliato) {
        // Shopify ha detto di no e il motivo lo sa solo lui: si torna alla via
        // lunga, che la pagina del carrello mostra l'errore per esteso.
        form.submit();
      }
    } catch (errore) {
      atteso.reject(errore);
      // Rete caduta a meta': invece di lasciare un bottone che gira a vuoto,
      // si manda avanti il form vero. Peggio l'attesa muta.
      form.submit();
    } finally {
      bottone?.removeAttribute('aria-busy');
    }
  });
}
